import React, { useState } from "react";


const Formd = () => {
    const [fullName, setFullName] = useState({
        fname: "",
        lname: "",
        email: "",
        mobile: "",
    });


    const inputEvent = (event) => {
        // console.log(event.target.value);
        // console.log(event.target.name);

        // const value = event.target.value;
        // const name = event.target.name;
        const {value, name} = event.target;

        setFullName((preValue => {

            return{
                ...preValue,
                [name]: value,
            }

            // if (name === "fname") {
            //     return {
            //         fname: value,
            //         lname: preValue.lname,
            //         email: preValue.email,
            //         mobile: preValue.mobile,
            //     }
            // } else if (name === "lname") {
            //     return {
            //         fname: preValue.fname,
            //         lname: value,
            //         email: preValue.email,
            //         mobile: preValue.mobile,
            //     }
            // } else if (name === "email") {
            //     return {
            //         fname: preValue.fname,
            //         lname: preValue.lname,
            //         email: value,
            //         mobile: preValue.mobile,
            //     }
            // } else if (name === "mobile") {
            //     return {
            //         fname: preValue.fname,
            //         lname: preValue.lname,
            //         email: preValue.email,
            //         mobile: value,
            //     }
            // }

        }))
    }

    const onSubmit = (event) => {
        event.preventDefault();
        //alert('Submitted');

    }
    return (
        <>
            <div>
                <form onSubmit={onSubmit}>
                    <h1>Hello {fullName.fname} {fullName.lname}  {fullName.email} {fullName.mobile}</h1>
                   <input type="text" className="form-control" placeholder="Enter your name" name="fname" onChange={inputEvent} value={fullName.fname} />
                    <input type="text" className="form-control" placeholder="Enter your name" name="lname" onChange={inputEvent} value={fullName.lname} />
                    <input type="email" className="form-control" placeholder="Enter your name" name="email" onChange={inputEvent} value={fullName.email} autoComplete="off" />
                    <input type="number" className="form-control" placeholder="Enter your name" name="mobile" onChange={inputEvent} value={fullName.mobile} />
                    <button type="submit" className="btn btn-primary">Submit</button>
                </form>
            </div>
        </>
    )
}

export default Formd;